import { useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import useMutateIndustrySpecialist from "./hooks/useMutateIndustrySpecialist";
import { usAdminAppRoutes } from "route-definitions";
import BaseModal from "../shared/components/BaseModal";
import BaseButton from "components/common/BaseButton";
import { IndustrySpecialistFormData } from "./components/create-industry-specialist-form/create-industry-specialist.schema";
import CreateIndustrySpecialistForm from "./components/create-industry-specialist-form/CreateIndustrySpecialistForm";
import EntityPageLayout from "../shared/components/EntityPageLayout";

const CreateIndustrySpecialist = () => {
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const intl = useIntl();

  const {
    createIndustrySpecialist,
    createIndustrySpecialistLoading,
    createIndustrySpecialistSuccess,
    createIndustrySpecialistError,
  } = useMutateIndustrySpecialist({
    onCreateSuccess: () => {
      setModalIsOpen(true);
    },
    onCreateError: () => {
      setModalIsOpen(true);
    },
  });

  const onSubmit = (data: IndustrySpecialistFormData) => {
    createIndustrySpecialist(data);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    if (createIndustrySpecialistSuccess) {
      history.push(usAdminAppRoutes.industrySpecialists);
    }
  };

  return (
    <EntityPageLayout headerMessage="usAdmin.createIndustrySpecialist">
      <BaseModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        footer={
          <BaseButton
            handleSubmit={handleCloseModal}
            text={intl.formatMessage({ id: "usAdmin.ok" })}
          />
        }
      >
        {createIndustrySpecialistSuccess && (
          <h2>
            {intl.formatMessage({
              id: "usAdmin.industrySpecialistCreatedSuccessfully",
            })}
          </h2>
        )}
        {createIndustrySpecialistError && (
          <h2>
            {intl.formatMessage({ id: "usAdmin.industrySpecialistExists" })}
          </h2>
        )}
      </BaseModal>
      <CreateIndustrySpecialistForm
        onSubmit={onSubmit}
        isSubmitting={createIndustrySpecialistLoading}
      />
    </EntityPageLayout>
  );
};

export default CreateIndustrySpecialist;
